import React, { useState, useContext } from 'react';
import * as routes from '../constants/routes';
import Navbar from 'react-bootstrap/Navbar'
import { Container } from 'react-bootstrap'
import Image from 'react-bootstrap/Image';
import brandIcon from '../assets/brand-icon.png'
import SessionContext from './SessionContext';
import HelpTile from './HelpTile';
import { withRouter } from 'react-router-dom';

function MainLayout({ history, ...props}) {
  const sessionContext = useContext(SessionContext);

  const [showSettings, setShowSettings] = useState(false)

  return (
    <>
      <Navbar>
        <Navbar.Brand onClick={() => history.push(routes.SCHEDULES)} style={{cursor: 'pointer'}}><img src={brandIcon} alt="WFH Scheduler" /></Navbar.Brand>
        <Navbar.Text className="brandHeader">{sessionContext.household && sessionContext.household.title}</Navbar.Text>
        <Navbar.Collapse className="justify-content-end">
          <div style={{cursor: 'pointer'}} onClick={() => history.push(routes.SETTINGS)}>
            {sessionContext.user && <Image src={sessionContext.user.picture} style={{width:45, height:45}} roundedCircle />}
          </div>
        </Navbar.Collapse>
      </Navbar>
      <Container>
        {props.children}
        <HelpTile></HelpTile>
      </Container>
    </>
  );
}

export default withRouter(MainLayout);
